import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "./Logo";
import { Reveal } from "./Reveal";

export default function LegalPage({ doc }) {
  return (
    <section className="section !pt-32 pb-24" data-testid="page-legal">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <Link
          to="/"
          data-testid="legal-home-link"
          className="inline-flex items-center gap-2 text-sm text-dusk hover:text-grape-soft transition-colors"
        >
          <ArrowLeft size={15} /> Back to home
        </Link>
        <div className="mt-8">
          <Logo />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold mt-6" data-testid="legal-title">
          {doc.title}
        </h1>
        <div className="mt-7">
          {doc.intro.map((p, i) => (
            <p key={i} className="leading-relaxed text-dusk mt-4" data-testid={i === 0 ? "legal-intro" : undefined}>
              {p}
            </p>
          ))}
        </div>
        <div className="mt-12 space-y-10">
          {doc.sections.map((s, i) => (
            <Reveal key={i}>
              {s.sub ? (
                <h3 className="font-semibold text-[1.02rem] pt-2" data-testid={`legal-sub-${i}`}>{s.h}</h3>
              ) : (
                <h2 className="font-display text-xl font-semibold" data-testid={`legal-heading-${i}`}>{s.h}</h2>
              )}
              {s.p.map((para, j) => (
                <p key={j} className="mt-3 leading-relaxed text-dusk text-[0.95rem]">{para}</p>
              ))}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}